import { CustomMap } from '@vendor/libs/maps/maps';
import { AssociationBoundaryFeatures } from '@vendor/libs/maps/features';
import { DrawAssociationBoundaries, EditAssociationBoundaries, } from '@vendor/libs/maps/interactions';
import MapUtils from '@vendor/js/map-utils';
import { i18n } from '@vendor/libs/lang/lang';
import { Spinner } from '@vendor/js/spinner';
import Common from '@vendor/js/common';
import { Api } from '@vendor/js/api';
import { ErrorSwal } from '@vendor/libs/sweetalert2/sweetalert2';
const _AssociationsMapHandler = (function () {
    const card = $('[data-app-association_map_card]');
    let associationBoundaryFeatures = null;
    let id = null;
    /**
     * Initializes the map and sets up the necessary features and interactions.
     *
     * @function initMap
     * @returns {void}
     */
    const initMap = () => {
        const map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        associationBoundaryFeatures = new AssociationBoundaryFeatures({
            visibilityName: 'association-boundaries-current',
            visibilityListed: false,
        });
        map.addFeatures('associations', associationBoundaryFeatures);
    };
    /**
     * Sets up and adds a draw interaction for creating association boundaries on the map.
     *
     * @returns {void}
     */
    const addDrawInteraction = () => {
        const map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        // add interaction
        const drawAssociationBoundariesInteraction = new DrawAssociationBoundaries();
        map.addInteraction('draw-association-boundaries', drawAssociationBoundariesInteraction);
        drawAssociationBoundariesInteraction.on('end', function ({ feature }) {
            setBoundaries(feature);
        });
        drawAssociationBoundariesInteraction.on('start', function () {
            card.html(`
          Kontynuuj rysowanie granicy poprzez wyznaczanie kolejnych wierzchołków na mapie.<br/>
          Aby zakończyć rysowanie, naciśnij pierwszy wierzchołek lub naciśnij dwa razy ostatni wierzchołek.
      `);
        });
    };
    /**
     * Sets the boundaries of a given geographic feature on the map.
     * If fit is true, the map will automatically fit the boundaries.
     *
     * @param {any} geo - The geographic feature to set the boundaries for.
     * @param {boolean} [fit=false] - Flag indicating whether to fit the map to the boundaries.
     */
    const setBoundaries = (geo, fit = false) => {
        const geojson = MapUtils.geojsonFromAny(geo);
        if (!associationBoundaryFeatures) {
            return;
        }
        let map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        associationBoundaryFeatures.clear();
        card.html(i18n.trans('models/associations.pages.common.boundaries.edit_help'));
        id = geojson.id ?? null;
        associationBoundaryFeatures.fromGeoJSON(geojson);
        const input = $('[name="geojson"]');
        if (input.length) {
            input.val(geojson.toString()).trigger('change');
        }
        if (fit) {
            associationBoundaryFeatures.fit();
        }
        // add edit interaction
        map.removeInteraction('draw-association-boundaries');
        const editAssociationInteraction = new EditAssociationBoundaries({
            customFeaturesToEdit: associationBoundaryFeatures,
        });
        map.addInteraction('edit-association-boundaries', editAssociationInteraction);
        editAssociationInteraction.on('end', ({ features }) => {
            const feature = features.item(0);
            // have to remove the "customFeatures" reference
            feature.unset('customFeatures');
            input.val(MapUtils.geojsonFromAny(feature).toString()).trigger('change');
        });
    };
    const handleAdministrativeUnitBoundaries = () => {
        const modal = $('#set_boundaries_from_unit_modal');
        let select = modal.find('select');
        if (!select.length || typeof select[0].tomselect == 'undefined') {
            return;
        }
        const tomSelect = select[0].tomselect;
        $('[data-bs-target="#set_boundaries_from_unit_modal"]').on('click', async function () {
            const form = modal.closest('form');
            if (!modal.find('select options').length) {
                const spinner = new Spinner();
                try {
                    const response = await Api.get('/administrative-units');
                    for (let i = 0; i < response.data.units.length; i++) {
                        let unit = response.data.units[i];
                        // Add option group for parent
                        if (unit.type == 2) {
                            tomSelect.addOptionGroup(unit.id.toString(), {
                                label: unit.name,
                            });
                            tomSelect.addOption({
                                value: unit.id,
                                text: unit.name,
                                optgroup: unit.id,
                            });
                        }
                        // Add option for child
                        if (unit.type == 1) {
                            let parentCode = unit.code.substring(0, 4);
                            let parentId = response.data.units.find((u) => u.type === 2 && u.code === parentCode)?.id;
                            tomSelect.addOption({
                                value: unit.id,
                                text: unit.name,
                                optgroup: parentId,
                            });
                        }
                    }
                }
                catch (err) {
                    Common.handleErrorResponse(err);
                }
                finally {
                    spinner.destroy();
                }
            }
        });
        modal
            .find('[data-app-set_boundaries_from_unit_modal-action="cancel"]')
            .on('click', function () {
            Common.closeModal(modal);
        });
        modal
            .find('[data-app-set_boundaries_from_unit_modal-action="submit"]')
            .on('click', async function () {
            const value = tomSelect.getValue();
            if (!value) {
                ErrorSwal.fire({
                    text: i18n.trans('models/associations.pages.common.boundaries.set_from_unit.required_validation_error'),
                });
                return;
            }
            const spinner = new Spinner();
            try {
                const response = await Api.get(`/administrative-units/${value}`);
                Common.closeModal(modal);
                let geojson = response.data.unit.geojson;
                if (geojson.type != 'Feature') {
                    geojson = {
                        type: 'Feature',
                        geometry: geojson,
                        bbox: geojson.bbox,
                    };
                }
                setBoundaries(geojson, true);
            }
            catch (err) {
                Common.handleErrorResponse(err);
            }
            finally {
                spinner.destroy();
            }
        });
    };
    return {
        // Public functions
        init: function () {
            initMap();
        },
        addDrawInteraction,
        setBoundaries,
        handleAdministrativeUnitBoundaries,
    };
})();
window.AssociationsMapHandler = _AssociationsMapHandler;
